<template>
  <div class="card">
    <slot name="card"></slot>
  </div>
</template>